"use client";

import { createContext, useContext, useState, ReactNode } from 'react';

interface ContextItem {
  id: string;
  text: string;
  wordCount: number;
}

interface ContextStoreType {
  contexts: ContextItem[];
  addContext: (text: string) => void;
  removeContext: (id: string) => void;
  clearContexts: () => void;
}

const ContextStore = createContext<ContextStoreType | undefined>(undefined);

export function ContextProvider({ children }: { children: ReactNode }) {
  const [contexts, setContexts] = useState<ContextItem[]>([]);

  const addContext = (text: string) => {
    const wordCount = text.trim().split(/\s+/).length;
    const newContext: ContextItem = {
      id: Date.now().toString(),
      text: text.trim(),
      wordCount
    };
    setContexts(prev => [...prev, newContext]);
  };

  const removeContext = (id: string) => {
    setContexts(prev => prev.filter(context => context.id !== id));
  };

  const clearContexts = () => {
    setContexts([]);
  };

  return (
    <ContextStore.Provider value={{
      contexts,
      addContext,
      removeContext,
      clearContexts
    }}>
      {children}
    </ContextStore.Provider>
  );
}

export function useContextStore() {
  const context = useContext(ContextStore);
  if (context === undefined) {
    throw new Error('useContextStore must be used within a ContextProvider');
  }
  return context;
} 